<template>
  <v-text-field
    v-bind="$attrs"
    hide-details="auto"
    v-on="$listeners"
    dense
    reverse
    type="date"
  />
</template>

<script>
export default {};
</script>
